<template>
  <div class="countainer">
    <div class="row">
      <div class="col-md-3"></div>
      <div class="col-lg-6 col-sm-12 col-12">
        <FastAccessAutomation></FastAccessAutomation>
      </div>
      <div class="col-md-3"></div>
    </div>

    <div class="row">
      <div class="col-md-2 col-12">
        <div class="row">
          <div class="col-md-12 col-12">
            <Card :StyleProp="'my-1'">
              <template v-slot:header>
                <small class="text-center Pointer hover-warning" :class="Cartable[0] == true ? 'text-warning' : ''" @click="SetCartableState(0)"><i class="fad fa-level-down ml-4"></i> وارده باز </small>
              </template>
            </Card>
          </div>
          <div class="col-md-12 col-12">
            <Card :StyleProp="'my-1'"
              ><template v-slot:header
                ><small class="text-center Pointer hover-warning" :class="Cartable[1] == true ? 'text-warning' : ''" @click="SetCartableState(1)"><i class="fad fa-inbox-in ml-4"></i> وارده بایگانی</small></template
              ></Card
            >
          </div>
          <div class="col-md-12 col-12">
            <Card :StyleProp="'my-1'"
              ><template v-slot:header
                ><small class="text-center Pointer hover-warning" :class="Cartable[2] == true ? 'text-warning' : ''" @click="SetCartableState(2)"><i class="fad fa-level-up ml-4"></i> صادره باز</small></template
              ></Card
            >
          </div>
          <div class="col-md-12 col-12">
            <Card :StyleProp="'my-1'"
              ><template v-slot:header
                ><small class="text-center Pointer hover-warning" :class="Cartable[3] == true ? 'text-warning' : ''" @click="SetCartableState(3)"><i class="fad fa-inbox-out ml-4"></i> صادره بایگانی</small></template
              ></Card
            >
          </div>
        </div>
      </div>
      <div class="col-md-10 col-12">
        <div class="row">
          <div class="col-12 table-responsive">
            <Card class="w-100">
              <template v-slot:content>
                <!-- Start Filter Tag -->
                <div class="row mb-3" v-if="Cartable[0] == true || Cartable[3] == true || Cartable[1] == true">
                  <div class="col-lg-3 col-12">
                    <small>انتخاب فرم</small>
                    <select class="form-control" v-model="Filter.FromautomationId">
                      <option :value="item.id" v-for="(item, key) in FormList" :key="key">{{ item.formName }}</option>
                      <option :value="-1">همــــــــــه</option>
                    </select>
                  </div>
                  <!-- <div class="col-lg-3 col-12" v-if="$session.get('UserInfo').tblGrpId == 1 || $session.get('UserInfo').tblUserId == 205245"> -->
                  <div class="col-lg-3 col-12" v-if="Cartable[0] == true">
                    <small>انتخاب کاربر</small>
                    <SearchableCombo
                      :ActiveDelete="true"
                      :key="'UserFilter'"
                      :edit="false"
                      :grp="0"
                      :code="null"
                      @ResultCombo="GetResulUserId"
                      @deleteSelected="deleteSelectComboUserFilter"
                      :rownumintable="3"
                      :defaultvalue="false"
                      :action="'TblCrmCombo/GetUserDatails'"
                      :method="'POST'"
                      :idinput="'UserId'"
                      :keyItem="'UserId'"
                      :disabled="false"
                    >
                    </SearchableCombo>
                  </div>
                  <div class="col-md-3 col-12">
                    <small> {{ Cartable[0] == true ? 'در تاریخ ' : 'از تاریخ' }} </small>
                    <date-picker color="dimgray" input-class="required form-control" v-model="Filter.tarixAz" clearable :editable="true" :placeholder="Cartable[0] == true ? 'در تاریخ ' : 'از تاریخ'"></date-picker>
                  </div>
                  <div class="col-md-3 col-12" v-if="Cartable[3] == true || Cartable[1] == true">
                    <small> تا تاریخ </small>
                    <date-picker color="dimgray" input-class="required form-control" v-model="Filter.tarixTa" clearable :editable="true" placeholder=" از تاریخ "></date-picker>
                  </div>
                  <div class="col-md-3 col-12">
                    <button type="button" class="btn btn-success w-100 mt-4" @click="setFilter"><i class="fad fa-search mt-1 ml-2"></i> اعمال فیلتر</button>
                  </div>
                </div>
                <!-- End filter Tag -->

                <table class="table table-bordered table-hover mt-3" :key="Render + 'table'">
                  <thead>
                    <tr>
                      <th scope="col">ردیف</th>
                      <th scope="col" v-if="Cartable[0] == true || Cartable[1] == true">درخواست کننده</th>
                      <th scope="col">درخواست</th>
                      <th scope="col">تاریخ ثبت</th>
                      <th scope="col" v-if="Cartable[2] != true && Cartable[3] != true">توضیحات</th>
                      <th scope="col">وضعیت</th>
                      <th scope="col">عملیات</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(row, key) in Rows">
                      <tr :key="key + 'tr1'">
                        <td class="text-center" v-b-toggle="'collapse' + key">{{ row.rowNumber }}</td>
                        <td class="text-center" v-b-toggle="'collapse' + key" v-if="Cartable[0] == true || Cartable[1] == true">{{ row.nameUserReq }}</td>
                        <td class="text-center" v-b-toggle="'collapse' + key">{{ row.formName }}</td>
                        <td class="text-center" v-b-toggle="'collapse' + key" dir="ltr">{{ row.dateTimeInsert }}</td>
                        <td class="text-center" v-b-toggle="'collapse' + key" v-if="Cartable[2] != true && Cartable[3] != true">
                          <textarea class="form-control" rows="1" v-model="row.Description" placeholder="توضیحات" v-if="Cartable[1] != true"></textarea>
                          <small v-if="Cartable[1] == true && row.Description.length > 0" class="text-info">{{ row.Description }}</small>
                          <small v-if="Cartable[1] == true && row.Description.length == 0">ندارد</small>
                        </td>
                        <td class="text-center">
                          <!-- اگر هرچیزی بجز صادره باشد -->
                          <div class="" v-if="Cartable[1] != true && Cartable[2] != true && Cartable[3] != true">
                            <div class="d-inline" v-if="row.hasAccept">
                              <SearchableCombo
                                v-if="Cartable[1] != true"
                                :edit="false"
                                :grp="101"
                                @ResultCombo="GetResulGrp101"
                                :defaultvalue="row.tblcomboGrp101Vaziat"
                                :action="'TblCrmCombo/GetComboById'"
                                :method="'POST'"
                                :idinput="row.id"
                                :keyItem="'Combo' + row.id"
                                :ClassProps="'required text-center d-inline'"
                              ></SearchableCombo>
                            </div>
                            <div class="d-inline" v-if="row.hasDo">
                              <select class="form-control text-center d-inline" @change="ChangeHasDo($event, row)">
                                <option :value="-1">انتخاب وضعیت</option>
                                <option :value="1085234">انجام شد</option>
                                <option :value="1085232">انجام نشد</option>
                              </select>
                            </div>
                          </div>
                          <div v-if="Cartable[1] == true">
                            <span class="badge badge-secondary px-2 font-weight-normal" v-if="row.tblcomboGrp101Vaziat == 2727">مرجوع شده</span>
                            <span class="badge badge-danger px-2 font-weight-normal" v-if="row.tblcomboGrp101Vaziat == 1085232">رد شده</span>
                            <span class="badge badge-warning px-2 font-weight-normal" v-if="row.tblcomboGrp101Vaziat == 1085233">درحال بررسی</span>
                            <span class="badge badge-success px-2 font-weight-normal" v-if="row.tblcomboGrp101Vaziat == 1085234">تایید شده</span>
                          </div>
                          <div class="" v-if="Cartable[2] == true || Cartable[3] == true">
                            <cartabl-table-detail :DetailList="row.detail"></cartabl-table-detail>
                          </div>
                        </td>
                        <td class="text-center">
                          <request-info
                            v-if="!Cartable[3] == true"
                            :RequestRow="row"
                            :ApiAction="ApiAction"
                            @Success="RefreshGrid"
                            @DataEdit="DataEdit"
                            :IsSarparast="Cartable[2] == true || Cartable[3] == true ? false : true"
                            :showInfo="Cartable[0] == true || Cartable[1] == true ? true : false"
                            :IsEdit="Cartable[2] == true || Cartable[3] == true ? true : false"
                            :IsDelete="Cartable[2] == true || Cartable[3] == true ? true : false"
                          ></request-info>
                          <div class="d-block" v-if="Cartable[2] != true && Cartable[3] != true">
                            <i class="fas fa-share mt-2 hover-warning Pointer text-secondary" title="مرجوع کردن" @click="Reject(row)" v-if="row.hasReject"></i>
                          </div>
                          <!-- <i class="fas fa-angle-down hover-success d-block mt-1 Pointer" v-b-toggle="'collapse' + key"></i> -->
                        </td>
                      </tr>
                      <tr :key="key + 'tr2'">
                        <td colspan="7" class="p-0 bg-detail">
                          <b-collapse :id="'collapse' + key" :accordion="'collapse'" class="mt-2">
                            <div class="m-1 row">
                              <div class="col-md-3 col-12" v-if="row.tblcombogrp103NoeMorakhasi">
                                <div>
                                  <span> نوع درخواست : </span>
                                  <span v-if="row.tblcombogrp103NoeMorakhasi == 1085237">استحقاقی </span>
                                  <span v-if="row.tblcombogrp103NoeMorakhasi == 1085238">استعلاجی </span>
                                  <span v-if="row.tblcombogrp103NoeMorakhasi == 1085239">بدون حقوق </span>
                                </div>
                              </div>
                              <div class="col-md-3 col-12" v-if="row.tblCombogrp102NoeDarkhast || row.tblComboGrp102RoozaneSaati">
                                <div>
                                  <span> حالت درخواست : </span>
                                  <span v-if="row.tblCombogrp102NoeDarkhast == 1085236">ساعتی </span>
                                  <span v-if="row.tblCombogrp102NoeDarkhast == 1085235">روزانه </span>
                                  <span v-if="row.tblComboGrp102RoozaneSaati == 1085236">ساعتی </span>
                                  <span v-if="row.tblComboGrp102RoozaneSaati == 1085235">روزانه </span>
                                </div>
                              </div>
                              <div class="col-md-3 col-12" v-if="row.tarixAz || row.date">
                                <div>
                                  <span> از تاریخ : </span>
                                  <span v-if="row.tarixAz"> {{ row.tarixAz }}</span>
                                  <span v-if="row.date"> {{ row.date }}</span>
                                </div>
                              </div>
                              <div class="col-md-3 col-12" v-if="(row.tarixTa || row.date) && row.tblFormAutomationId != 3 && row.startTime == 'null' && row.endTime == 'null'">
                                <div>
                                  <span> تا تاریخ : </span>
                                  <span v-if="row.tarixTa"> {{ row.tarixTa }}</span>
                                  <span v-if="row.date"> {{ row.date }}</span>
                                </div>
                              </div>
                              <div class="col-md-3 col-12" v-if="!row.tarixAz && !row.date">
                                <div>
                                  <span> تاریخ ثبت : </span>
                                  <span dir="ltr"> {{ row.dateTimeInsert }}</span>
                                </div>
                              </div>
                              <!-- حالت روزانه مامویت -->
                              <!-- 1085236 ساعتی -->
                              <!-- 1085235 روزانه -->
                              <!--  حالت ساعتی ماموریت -->
                              <div class="col-md-3 col-12" v-if="row.tblFormAutomationId != 1 && row.tblComboGrp102RoozaneSaati && row.tblComboGrp102RoozaneSaati != 1085235">
                                <span> از ساعت : </span>
                                <span> {{ row.startTime }} </span>
                              </div>
                              <!--  حالت ساعتی ماموریت -->
                              <div class="col-md-3 col-12" v-if="row.tblFormAutomationId != 1 && row.tblComboGrp102RoozaneSaati && row.tblComboGrp102RoozaneSaati != 1085235">
                                <span> تا ساعت : </span>
                                <span> {{ row.endTime }} </span>
                              </div>
                              <!--  حالت ساعتی مرخصی -->
                              <div class="col-md-3 col-12" v-if="row.tblFormAutomationId == 1 && row.startTime != 'null'">
                                <span>از ساعت : </span>
                                <span> {{ row.startTime }} </span>
                              </div>
                              <!--  حالت ساعتی مرخصی -->
                              <div class="col-md-3 col-12" v-if="row.tblFormAutomationId == 1 && row.endTime != 'null'">
                                <span>تا ساعت : </span>
                                <span> {{ row.endTime }} </span>
                              </div>
                              <div class="col-md-3 col-12" v-if="row.countDate">
                                <span> به مدت : </span>
                                <span>{{ row.countDate }}</span>
                                <span> روز </span>
                                <span></span>
                              </div>
                              <div class="col-md-3 col-12" v-if="row.dayCount && row.tblFormAutomationId == 2">
                                <span> به مدت : </span>
                                <span>{{ row.dayCount }}</span>
                                <span> روز </span>
                                <span></span>
                              </div>
                              <!-- پیوست دیگر حالت ها -->
                              <div class="col-md-4 col-12" v-if="row.filepath != null && row.filepath != 'null'">
                                <div class="w-100 row my-1 text-center">
                                  <div class="col-8 text-center">
                                    <small class=""> فایل پیوستی : </small>
                                  </div>
                                  <div class="col-4 text-right">
                                    <a download="row.id" target="new" v-if="row.filePath != null && row.tblFormAutomationId == 1" :href="$cookies.get('URL') + row.filePath"> <i class="fad fa-download hover-warning"></i></a>
                                    <a download="row.id" target="new" v-if="row.filepath != null && row.tblFormAutomationId != 1" :href="$cookies.get('URL') + row.filepath"> <i class="fad fa-download hover-warning"></i></a>
                                  </div>
                                </div>
                              </div>
                              <!-- پیوست مرخصی -->
                              <div class="col-md-4 col-12" v-if="row.filePath != null && row.filePath != 'null'">
                                <div class="w-100 row my-1 text-center">
                                  <div class="col-8 text-center">
                                    <small class=""> فایل پیوستی : </small>
                                  </div>
                                  <div class="col-4 text-right">
                                    <a download="row.id" target="new" v-if="row.filePath != null && row.tblFormAutomationId == 1" :href="$cookies.get('URL') + row.filePath"> <i class="fad fa-download hover-warning"></i></a>
                                    <a download="row.id" target="new" v-if="row.filePath != null && row.tblFormAutomationId != 1" :href="$cookies.get('URL') + row.filePath"> <i class="fad fa-download hover-warning"></i></a>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6 col-12" v-if="row.des">
                                <span> توضیحات : </span>
                                <span>{{ row.des }}</span>
                              </div>
                              <div class="col-md-3 col-12" v-if="row.commodity">
                                <span> کالا : </span>
                                <span>{{ row.commodity }}</span>
                              </div>
                              <div class="col-md-3 col-12" v-if="row.count">
                                <span> تعداد : </span>
                                <span>{{ row.count }}</span>
                              </div>
                              <div class="col-md-3 col-12" v-if="row.amount">
                                <span> مبلغ: </span>
                                <span>{{ $Comma3ragham(row.amount) }}</span>
                              </div>
                              <div class="col-md-6 col-12" v-if="row.for">
                                <span> توضیحات درخواست کننده : </span>
                                <span>{{ row.for }}</span>
                              </div>
                              <div class="col-md-6 col-12" v-if="row.description">
                                <span> توضیحات درخواست کننده : </span>
                                <span>{{ row.description }}</span>
                              </div>
                            </div>
                          </b-collapse>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <div v-if="Rows.length == 0" class="alert border w-100 text-center" role="alert">اطلاعاتی یافت نشد</div>
                <Pagination :List="Rows" :CountOfPage="5" @ListResult="ListResult" :key="Render"> </Pagination>
              </template>
            </Card>
          </div>
        </div>
      </div>
    </div>
    <modal v-if="MODAL" :InheritanceTheme="true" :IsFooter="false" :Size="'Sm'" @Close="CloseRejectModal">
      <template v-slot:body>
        <div class="row px-5" id="RejectForm" v-if="ListSteepWorkflow.length">
          <div class="col-12 text-center mb-3 text-warning">انتخاب مرحلـــه ارجاع نامه</div>
          <div class="col-12">
            <small>توضیحات مربوط به ارجاع</small>
            <input class="form-control required" type="text" v-model="RejectDescription" />
            <hr />
          </div>
          <div class="col-md-6 col-12" v-for="(item, key) in ListSteepWorkflow" :key="key">
            <div class="box p-2 Pointer" @click="ChangeActiveSteep(item)">
              {{ item.levelName }}
            </div>
          </div>
        </div>
        <div class="row px-5" v-else>
          <div class="col-12 alert alert-warning text-dark">در این مرحله امکان ارجاع وجود ندارد</div>
        </div>
      </template>
    </modal>
    <Loading v-if="loadingRender"></Loading>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import FastAccessAutomation from './FastAccessAutomation.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import RequestInfo from '@/components/AutomAtion/RequestInfo.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Pagination from '@/components/Pagination/Pagination.vue'
import CartablTableDetail from './CartablTableDetail.vue'
import Modal from '@/pages/Modal/Modal.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import moment from 'moment-jalaali'
import Loading from '@/components/Loader/Loading.vue'

export default {
  name: 'Cartabl',
  components: { Card, FastAccessAutomation, BnpGrid, RequestInfo, SearchableCombo, Pagination, CartablTableDetail, Modal, datePicker: VuePersianDatetimePicker, Loading, SearchableCombo },
  data() {
    return {
      Cartable: [false, false, false, false],
      Rows: [],
      Render: 0,
      Column: [
        {
          name: 'nameUserReq',
          label: ' درخواست کننده',
          visibility: true,
        },
        {
          name: 'formName',
          label: 'درخواست',
          visibility: true,
        },
        {
          name: 'tarixAz',
          label: 'از تاریخ',
          visibility: true,
        },
        {
          name: 'tarixTa',
          label: 'تا تاریخ',
          visibility: true,
        },
        {
          name: 'startTime',
          label: 'از ساعت ',
          visibility: true,
        },
        {
          name: 'endTime',
          label: 'تا ساعت ',
          visibility: true,
        },
        {
          name: 'filePath',
          label: 'پیوست',
          visibility: true,
        },
        {
          name: 'tblcombogrpId101VaziatName',
          label: 'وضعیت',
          visibility: true,
        },
      ],
      MODAL: false,
      RejectDescription: '',
      Filter: { FromautomationId: -1, tarixAz: '', tarixTa: '', tblUserId: null },
      FormList: [],
      loadingRender: false,
    }
  },
  methods: {
    SetCartableState(CartablIndex) {
      this.Cartable = [false, false, false, false]
      this.Cartable[CartablIndex] = true
      this.GetData(CartablIndex)
    },
    GetDataVarede(Filter) {
      this.loadingRender = true
      this.Rows = []
      let ListRows = []
      this.tblformAutomationId = 1
      var AxiosGet = { ArryfildValue: {}, Method: 'post', Action: 'Cartabl/Varede', Token: this.$session.get('Token') }
      let in_Varede = { isArchive: false }
      AxiosGet.ArryfildValue = in_Varede
      this.$PostData(AxiosGet).then((res) => {
        if (res.status == 'Success') {
          var result = {}
          res.data.forEach((elm) => {
            elm.forEach((el) => {
              for (var id in el.selProcessWorkFlowForUser) {
                el.tblLeaveRequests[id] = el.selProcessWorkFlowForUser[id]
              }
              el.tblLeaveRequests['Description'] = ''
              this.Rows.push(JSON.parse(JSON.stringify(el.tblLeaveRequests)))
              ListRows.push(JSON.parse(JSON.stringify(el.tblLeaveRequests)))
              this.Render++
            })
          })
          if (Filter) {
            if (Filter.FromautomationId != -1) {
              this.Rows = ListRows.filter((elm) => elm.tblFormAutomationId == Filter.FromautomationId)
            }
            if (Filter.tblUserId != null) {
              this.Rows = this.Rows.filter((elm) => elm.tblUserId == Filter.tblUserId)
            }
            if (Filter.tarixAz.trim() != '') {
              this.Rows = this.Rows.filter((elm) => elm.dateTimeInsert.substr(0, 10) == Filter.tarixAz.trim())
              this.Render++
            }
          }
          this.loadingRender = false
        }
      })
    },
    GetDataVaredeBaygani(Filter) {
      this.loadingRender = true
      this.Rows = []
      let ListRows = []
      this.tblformAutomationId = 1
      var AxiosGet = { ArryfildValue: {}, Method: 'post', Action: 'Cartabl/Varede', Token: this.$session.get('Token') }
      let in_Varede = { isArchive: true }
      AxiosGet.ArryfildValue = in_Varede
      this.$PostData(AxiosGet).then((res) => {
        console.log("😎 ~ this.$PostData ~ res:", res)
        if (res.status == 'Success') {
          this.loadingRender=false
          var result = {}
          if (res.data.length > 0) {
            res.data.forEach((elm) => {
              elm.forEach((el) => {
                for (var id in el.selProcessWorkFlowForUser) {
                  el.tblLeaveRequests[id] = el.selProcessWorkFlowForUser[id]
                }
                el.tblLeaveRequests['Description'] = ''
                this.Rows.push(JSON.parse(JSON.stringify(el.tblLeaveRequests)))
                ListRows.push(JSON.parse(JSON.stringify(el.tblLeaveRequests)))
                this.Render++
              })
            })
          }
          else{
            this.loadingRender=false
          }

          if (Filter) {
            if (Filter.FromautomationId != -1) {
              this.Rows = ListRows.filter((elm) => elm.tblFormAutomationId == Filter.FromautomationId)
            }
            if (Filter.tblUserId != null) {
              this.Rows = this.Rows.filter((elm) => elm.tblUserId == Filter.tblUserId)
            }
            if (Filter.tarixAz.trim() != '') {
              this.Rows = this.Rows.filter((elm) => elm.dateTimeInsert.substr(0, 10) >= Filter.tarixAz.trim())
              this.Render++
            }
            if (Filter.tarixTa.trim() != '') {
              this.Rows = this.Rows.filter((elm) => elm.dateTimeInsert.substr(0, 10) <= Filter.tarixTa.trim())
              this.Render++
            }
            this.loadingRender = false
          }
        }
      })
    },
    GetDataSadere() {
      this.loadingRender = true
      this.Rows = []
      var AxiosGet = { ArryfildValue: {}, Method: 'post', Action: 'Cartabl/Sadere', Token: this.$session.get('Token') }
      this.$PostData(AxiosGet).then((res) => {
        if (res.status == 'Success') {
          var result = {}
          res.data.forEach((elm) => {
            elm.forEach((el) => {
              for (var id in el.selProcessWorkFlowForUser) {
                el.tblLeaveRequests[id] = el.selProcessWorkFlowForUser[id]
                el.tblLeaveRequests['detail'] = el.detail
              }
              el.tblLeaveRequests['Description'] = ''
              this.Rows.push(JSON.parse(JSON.stringify(el.tblLeaveRequests)))
            })
          })
          this.loadingRender = false
          this.Render++
        }
      })
    },
    GetDataSadereBaygani(Filter) {
      this.loadingRender = true
      this.Rows = []
      let temp = []
      let ListRows = []
      var AxiosGet = { ArryfildValue: {}, Method: 'post', Action: 'Cartabl/Sadere', Token: this.$session.get('Token') }
      let in_Sadere = { isArchive: true }
      AxiosGet.ArryfildValue = in_Sadere
      this.$PostData(AxiosGet).then((res) => {
        if (res.status == 'Success') {
          var result = {}
          res.data.forEach((elm) => {
            elm.forEach((el) => {
              for (var id in el.selProcessWorkFlowForUser) {
                el.tblLeaveRequests[id] = el.selProcessWorkFlowForUser[id]
                el.tblLeaveRequests['detail'] = el.detail
              }
              el.tblLeaveRequests['Description'] = ''
              this.Rows.push(JSON.parse(JSON.stringify(el.tblLeaveRequests)))
              ListRows.push(JSON.parse(JSON.stringify(el.tblLeaveRequests)))
              this.Render++
            })
          })
          if (Filter) {
            if (Filter.FromautomationId != -1) {
              this.Rows = ListRows.filter((elm) => elm.tblFormAutomationId == Filter.FromautomationId)
            }
            if (Filter.tblUserId != null) {
              this.Rows = this.Rows.filter((elm) => elm.tblUserId == Filter.tblUserId)
            }
            if (Filter.tarixAz.trim() != '') {
              this.Rows = this.Rows.filter((elm) => elm.dateTimeInsert.substr(0, 10) >= Filter.tarixAz.trim())
              this.Render++
            }
            if (Filter.tarixTa.trim() != '') {
              this.Rows = this.Rows.filter((elm) => elm.dateTimeInsert.substr(0, 10) <= Filter.tarixTa.trim())
              this.Render++
            }
            this.loadingRender = false
          }
        }
      })
    },
    RefreshGrid(status) {
      if (status == true) {
        this.GetData()
      }
    },
    ListResult(val) {
      this.Rows = val
      // this.Render++
    },
    GetResulGrp101(val) {
      if (val.id && val.id != 1085233 && val.id != 2727) {
        let Vaziat = val.id == 1085232 ? 'رد شد ' : val.id == 1085234 ? 'تایید شد' : 'نامعلوم'
        this.$SweetQustion('تغییر وضعیت', 'از تغییر وضعیت درخواست به ' + Vaziat + ' اطمینان دارید ؟ ', 'warning', 'تایید', ' انصراف ', val, this.Accept, this.Cancel)
      }
    },
    Accept(val) {
      const IdRow = Number(val.key.split('Combo')[1])
      // console.log("😎 ~ Accept ~ val:", this.Rows.find((x) => x.id == IdRow))
      let Vaziat = val.id == 1085232 ? 'رد شد ' : val.id == 1085234 ? 'تایید شد' : 'نامعلوم'
      var SendData = { Action: 'ListProcessWorkFlow/ChangeComboGrp101VAaziat', Method: 'POST', ArryfildValue: null, Token: this.$session.get('Token') }
      var formData = new FormData()
      formData.append('id', IdRow)
      formData.append('tblComboGrpId101Vaziat', val.id)
      formData.append('fkId', this.Rows.find((x) => x.id == IdRow).fkId)
      formData.append('Description', this.Rows.find((x) => x.id == IdRow).Description)
      formData.append('Condition', this.Rows.find((x) => x.id == IdRow).condition)
      formData.append('tartib', this.Rows.find((x) => x.id == IdRow).tartib)
      formData.append('tblDepartmentId', this.Rows.find((x) => x.id == IdRow).tblDepartementId)
      formData.append('tblformAutomationId', this.Rows.find((x) => x.id == IdRow).tblFormAutomationId)
      formData.append('tarixAz', this.$GetFirstAndLastDayOfMonth().SDate)
      formData.append('tarixTa', this.$GetFirstAndLastDayOfMonth().EDate)
      SendData.ArryfildValue = formData
      // console.log(this.Rows.find((x) => x.id == IdRow).condition)
      // console.log(val)
      this.$PostFormData(SendData).then((result) => {
        //console.log('😎 ~ this.$PostFormData ~ result:', result)
        // if (result.status == 'Ok') {
        this.$toasted.success('تغییر وضعیت به حالت ' + Vaziat + ' با موفقیت انجام شد ')
        this.GetDataVarede()
        this.Render++
        // }
      })
    },
    ChangeHasDo(val, row) {
      var find = this.Rows.find((x) => x.id == row.id)
      find.tblcomboGrp101Vaziat = Number(val.target.value)
      if (val != -1) {
        let Vaziat = val.target.value == 1085232 ? 'انجام نشد ' : val.target.value == 1085234 ? 'انجام شد' : 'نامعلوم'
        this.$SweetQustion('تغییر وضعیت', 'از تغییر وضعیت درخواست به ' + Vaziat + ' اطمینان دارید ؟ ', 'warning', 'تایید', ' انصراف ', find, this.AcceptChangeHasDo, this.Cancel)
      }
    },
    AcceptChangeHasDo(val) {
      var SendData = { Action: 'ListProcessWorkFlow/ChangeComboGrp101VAaziat', Method: 'POST', ArryfildValue: null, Token: this.$session.get('Token') }
      var formData = new FormData()
      formData.append('id', val.id)
      formData.append('tblComboGrpId101Vaziat', val.tblcomboGrp101Vaziat)
      formData.append('fkId', val.fkId)
      formData.append('Description', val.Description)
      formData.append('Condition', val.condition)
      formData.append('tartib', val.tartib)
      formData.append('tblDepartmentId', val.tblDepartementId)
      formData.append('tblformAutomationId', val.tblFormAutomationId)
      formData.append('tarixAz', this.$GetFirstAndLastDayOfMonth().SDate)
      formData.append('tarixTa', this.$GetFirstAndLastDayOfMonth().EDate)
      SendData.ArryfildValue = formData
      this.$PostFormData(SendData).then((result) => {
        if (result.status == 'Ok') {
          this.$toasted.success('تغییر وضعیت  ' + ' با موفقیت انجام شد ')
          this.GetDataVarede()
          this.GetDataSadere()
          this.Render++
        }
      })
    },
    Reject(row) {
      this.RowRejected = row
      this.ListSteepWorkflow = []
      var SendData = { Action: 'ListProcessWorkFlow/Reject', Method: 'POST', ArryfildValue: null, Token: this.$session.get('Token') }
      var formData = new FormData()
      formData.append('fkid', row.fkId)
      SendData.ArryfildValue = formData
      this.$PostFormData(SendData).then((result) => {
        if (result.status == 'Success') {
          for (let i = 0; i < row.tartib; i++) {
            var f = result.data.find((x) => x.tartib == i && x.tartib != row.tartib)
            if (f) {
              this.ListSteepWorkflow.push(f)
            }
          }
          if (this.ListSteepWorkflow.length > 0) {
            this.MODAL = true
          } else {
            this.$toasted.error('در این مرحله امکان ارجاع نامه وجود ندارد ', { duration: 2500 })
          }
        }
      })
    },
    CloseRejectModal(value) {
      if (value == true) {
        this.MODAL = false
      }
    },
    ChangeActiveSteep(row) {
      // console.log('😎 ~ ChangeActiveSteep ~ row:', row)
      if (this.$ValidForm('RejectForm')) {
        this.$SweetQustion(' ارجاع نامه ', ' از ارجاع نامه به  ' + row.levelName + ' اطمینان دارید؟ ', 'warning', 'تایید', ' انصراف ', row, this.AcceptRejectToSteep, this.Cancel)
      }
    },
    AcceptRejectToSteep(row) {
      var formData = new FormData()
      formData.append('tblProcessWorkflowId', this.RowRejected.id)
      formData.append('fkid', this.RowRejected.fkId)
      formData.append('tartib', row.tartib)
      formData.append('tblAutomationId', row.tblFormAutomationId)
      formData.append('tblDepartemantId', row.tblDepartementId)
      formData.append('RejectDescription', this.RejectDescription)
      var SendData = { Action: 'ListProcessWorkFlow/ChangeActiveSteep', Method: 'POST', ArryfildValue: formData, Token: this.$session.get('Token') }
      this.$PostFormData(SendData).then((res) => {
        if (res.status == 'Success') {
          this.$toasted.success('ارجاع نامه با موفقیت انجام گردید', { duration: 2000 })
          this.GetData()
          this.Render++
        }
      })
    },
    GetFormList() {
      var AxiosGet = { ArryfildValue: {}, Method: 'Get', Action: 'Cartabl/formList', Token: this.$session.get('Token') }
      this.$GetData_Body(AxiosGet).then((res) => {
        this.FormList = res
        // console.log(this.FormList)
      })
    },
    SetFilterOnData(DataCartabl) {
      // DataCartabl.forEach((el)=>{
      //   console.log("😎 ~ SetFilterOnData ~ DataCartabl:", el)
      // })
      // this.Rows=DataCartabl
      // this.Render++
    },
    setFilter() {
      if (this.Cartable[0] == true) {
        this.GetDataVarede(this.Filter)
      } else if (this.Cartable[1] == true) {
        this.GetDataVaredeBaygani(this.Filter)
      } else {
        this.GetDataSadereBaygani(this.Filter)
      }
    },
    DataEdit(val) {
      this.$FindTableNameOnAutomationCartabl(val.tblFormAutomationId).then((res) => {
        this.$router.push({ name: res, params: { rowForEdit: JSON.stringify(val) } })
      })
    },
    ApiAction() {},
    GetData(CartablIndex) {
      let Cindex = CartablIndex
      if (!CartablIndex) {
        Cindex = this.Cartable.indexOf(true)
      }
      if (Cindex == 0) {
        this.Filter.tarixAz = ''
        this.GetDataVarede()
      }
      if (Cindex == 1) {
        this.Filter.tarixAz = this.$GetFirstAndLastDayOfMonth().SDate
        this.Filter.tarixTa = this.$GetFirstAndLastDayOfMonth().EDate
        this.GetDataVaredeBaygani(this.Filter)
      }
      if (Cindex == 2) {
        this.GetDataSadere()
      }
      if (Cindex == 3) {
        this.Filter.tarixAz = this.$GetFirstAndLastDayOfMonth().SDate
        this.Filter.tarixTa = this.$GetFirstAndLastDayOfMonth().EDate
        this.GetDataSadereBaygani(this.Filter)
      }
    },
    GetResulUserId(res) {
      if (res.id != null) {
        this.Filter.tblUserId = res.id
      }
    },
    deleteSelectComboUserFilter(res) {
      if (res.deleted == true) {
        this.Filter.tblUserId = null
      }
    },
  },
  created() {
    // let a = this.$GetJalaliDate().split('/')
    // a[2] = '01'
    // this.Filter.tarixAz = a[0] + '/' + a[1] + '/' + a[2]
    this.GetFormList()
  },
}
</script>
<style scoped>
tr {
  color: var(--sidebar-color-item) !important;
}
table {
  background: var(--sidebar-bg-color) !important;
  color: var(--sidebar-color-item);
}
td {
  border-color: var(--table-border-color) !important;
}
th {
  font-weight: normal;
  text-align: center;
  font-size: 12px;
  color: var(--sidebar-color-item) !important;
  border-color: var(--table-border-color) !important;
}
thead {
  border-color: var(--table-border-color) !important;
}
tr:hover {
  color: var(--sidebar-color-item) !important;
  background: var(--sidebar-bg-color) !important;
}
tbody {
  border: rgb(255, 255, 255) !important;
}
.bg-attacment {
  /* border: 2px dashed var(--logo-color); */
  border: 2px dashed rgb(255, 174, 0);
  border-radius: 5px;
}
.bg-detail {
  background: var(--sidebar-action-bg);
}
.box {
  /* border: 2px solid #b48810 !important; */
  background: var(--sidebar-bg-color);
  border-radius: 5px !important;
  text-align: center;
}
.box:hover {
  color: #5cb0ff;
}
</style>
